getHashPath